<input
  #stringInput
  [formControl]="phoneFormControl"
  type="text"
  [ngStyle]="config?.inputStyles"
  class="string-input"
/>
